<div class="modal-overlay" *ngIf="showErrorModal">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title mx-auto">{{ title }}</h5>
        </div>
        <div class="modal-body">
            {{ message }}
        </div>
        <div class="modal-footer">
            <button type="button" class="btn custombutton" (click)="onClose()">Aceptar</button>
        </div>
    </div>
</div>